<main class="mainlayout">
  <div
    class="ai-content-block flex"
    [class.left-block-collapsed]="sidebarCollapsed"
    appResizewindow>
    <section class="ai-left-block">
      <app-ai-leftmenu (collapsedChange)="sidebarCollapsed = $event"></app-ai-leftmenu>
    </section>
    <section
      #rightBlock
      class="ai-right-block"
      [class.ai-right-bg]="headerVisible()"
      [class.ai-right-block--flush]="onWorkflowBuilder()">
      <header
        class="ai-header"
        [class.ai-header--offline]="network.showOfflineHeader() && !onWorkflowBuilder()"
        [class.ai-header--scroll-hidden]="headerBarHidden()">
        <app-ai-header></app-ai-header>
      </header>
      <section class="ai-content-main">
        <router-outlet />
      </section>
    </section>
  </div>
</main>

